function parseNum(str) {
  return Number(str.replaceAll(",", "").replace(".", ""));
}

function parsePositionStr(posStr, genome) {
  const [startVal, endVal] = posStr.split("..");
  const [startPos, startChr] = (startVal || "").split(":").reverse();
  const [endPos, endChr] = (endVal || startVal || "").split(":").reverse();
  const chr1 = (startChr || "").replace(/^chr/, "");
  const chr2 = endChr ? endChr.replace(/^chr/, "") : chr1;
  const c1 = genome.getChrByKey(chr1.toLowerCase());
  const c2 = genome.getChrByKey(chr2.toLowerCase());
  const x0 = parseNum(startPos);
  const x1 = parseNum(endPos);

  const hasAll = posStr && startVal && startPos && startChr && endPos;
  const uorStart = c1 && (x0 < 0 || x0 >= c1.region.x1);
  const uorEnd = c2 && (x1 < 0 || x1 > c2.region.x1);

  if (!hasAll) throw new Error("Invalid position");
  if (!c1) throw new Error(`Not found chromosome: ${startChr}`);
  if (!c2) throw new Error(`Not found chromosome: ${endChr}`);
  if (uorStart) throw new Error(`Out of range: ${startPos} for ${c1.name}`);
  if (uorEnd) throw new Error(`Out of range: ${endPos} for ${c2.name}`);
  if (Number.isNaN(x1)) throw new Error(`${endPos} is not a number`);

  const start = c1.region.g0 + x0;
  const end = c2.region.g0 + x1;
  const [s, e] = [start, end].sort((a, b) => a - b);
  return { start: Math.max(0, s), end: e, c1, c2 };
}

export default parsePositionStr;
